module.exports = __webpack_public_path__ + "static/media/luminor-logo.aaf0b076.svg";